import { render, staticRenderFns } from "./departure_board.vue?vue&type=template&id=ed232bee&scoped=true&"
import script from "./departure_board.vue?vue&type=script&lang=js&"
export * from "./departure_board.vue?vue&type=script&lang=js&"
import style0 from "./departure_board.vue?vue&type=style&index=0&id=ed232bee&scoped=true&lang=css&"
import style1 from "./departure_board.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed232bee",
  null
  
)

export default component.exports